import React, { useState, useEffect } from 'react';
import  showDataWithPost  from '../../Utils/APIs/commonShowWithPost';
import TableHeading from '../../Components/common/table/Tableheading';
import { getCookie } from '../../Utils/cookies';
import { MdDeleteForever } from "react-icons/md";

const PaymentRequest = () => {
  const [empData, setEmpData] = useState('');
    useEffect(() => {
      const data = getCookie('empData') ? JSON.parse(getCookie('empData')) : '';
      console.log("empData",data)
      setEmpData(data);
    }, []);
  const [vehicleNo, setVehicleNo] = useState('');
  const [consignmentResponse, setConsignmentResponse] = useState([]);
  const [consignmentList, setConsignmentList] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);
  const [rate, setRate] = useState(0);
  const [dailyWages, setDailyWages] = useState(0);
  const [otherPayment, setOtherPayment] = useState(0);
  const commonList = [
    'SR No',
    'created By',
    'Vehicle No',
    'driver Contact',
    'Source Location',
    'Destination Location',
    'Travel Date',
    'Travel Distance',
    "#"
  ];
  if( empData.role === 'Transport') {
    commonList.unshift('#');
  }
  if(empData.role === 'Admin') {
    commonList.splice(2,2);
  }
  const findConsignmentList = async () => {
    if (!vehicleNo) {
      alert('Vehicle Number is required!');
      return;
    }
    const response = await showDataWithPost('track/showConsignmentList', { vehicleNo });
    if (response?.success) {
      if (response?.data?.length === 0) {
        alert('No consignments found for this vehicle number.');
      }
      setConsignmentResponse(response?.data);
    }
  };
  const truncateText = (text) => {
    if (!text) return '';
    return text.length > 10 ? `${text.slice(0, 10)}...` : text;
  };
  const handleSelectConsignment = (consignmentId, travelDistance) => {
    setConsignmentList((prev) =>
      prev.includes(consignmentId) ? prev : [...prev, consignmentId]
    );
    setTotalDistance((prev) => prev + travelDistance);
  };
  const handleDeselectConsignment = (consignmentId, travelDistance) => {
    setConsignmentList((prev) => prev.filter((id) => id !== consignmentId));
    setTotalDistance((prev) => prev - travelDistance);
  };
  useEffect(() => {
    console.log('Selected Consignments:', consignmentList);
  }, [consignmentList]);
  const requestPayment = async() => {
    if (consignmentList.length === 0) {
      alert('Please select at least one consignment.');
      return;
    }
    const totalAmount = totalDistance * Number(rate) + Number(dailyWages) + Number(otherPayment);
    // Here you would typically send the payment request to your backend
    alert(`Payment requested for total amount: Rs ${totalAmount}`);
    const response = await showDataWithPost('track/requestPayment', {
      consignmentList,
      totalDistance,
      rate: Number(rate),
      dailyWages: Number(dailyWages),
      otherPayment: Number(otherPayment),
      totalAmount,
    });
    console.log('Payment Response:', response);
      if (response?.success) {
        setConsignmentList([]);
        setTotalDistance(0);
        setRate(0);
        setDailyWages(0);
        setConsignmentResponse([]);
        setOtherPayment(0);
        setVehicleNo('');
      } else {
        alert(response?.message || 'Failed to send payment request.');
      }
  }
  // for Admin
  const [consignmentListAdmin, setConsignmentListAdmin] = useState([]);
  const [approvedResponse, setApprovedResponse] = useState(false);
  const findConsignmentListAdmin = async () => {
    const response = await showDataWithPost('track/PaymentRequestList',null);
    if (response?.success) {
      setConsignmentListAdmin(response?.data);
    }else{
      setConsignmentListAdmin([]);
      alert(response?.message,"fCLA" || 'Failed to fetch payment requests.');
    }
  }
  useEffect(() => {
    if (empData.role === 'Admin' || empData.role === 'Super Admin') {
      findConsignmentListAdmin();
    }
  }, [empData.role, approvedResponse]);

  const consignmentApprovedByAdmin = async (id) => {
    alert('Are you sure you want to approve this consignment?');
    const response = await showDataWithPost('track/consignmentApprovedByAdmin', { id });
    if (response?.success){
      setApprovedResponse(!approvedResponse);
    }else{
      alert(response?.message || 'Failed to approve consignment.');
    }
  }
  const consignmentRejectByAdmin = async (consignmentId, paymentId) =>{
    alert("Are you sure you want to reject this consignment.")
    const response = await showDataWithPost(
      "track/consignmentRejectByAdmin",
      {
        consignmentId, 
        paymentId
      }
    );
    if(response?.success){
      setApprovedResponse(!approvedResponse);
    }else{
      alert(response?.message || 'Failed to reject consignment.');
    }
  } 
  return (
    <div className="w-full flex flex-col pr-6 overflow-auto ">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
          T<span className="text-lg">RANSPORT</span> P<span className="text-lg">AYMENT</span> S<span className="text-lg">YSTEM</span>
        </h1>
      </div>
      {(empData.role === 'Transport' || (empData.role === 'Admin' && empData.department !=="Department Head"))  &&  <>
      <div className="flex gap-4 justify-center items-center mt-4">
        <label htmlFor="vehicle_no" className="block mb-2 text-sm font-medium text-gray-900">
          Vehicle No.<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="vehicle_no"
          onChange={(e) => setVehicleNo(e.target.value)}
          value={vehicleNo}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-64 p-2.5"
          placeholder="Vehicle No"
          required
        />
        <button
          type="button"
          className="text-dark bg-yellow-500 ml-2 hover:bg-yellow-400 font-medium rounded-sm text-sm px-5 py-2.5"
          onClick={findConsignmentList}
        >
          Search
        </button>
      </div>
      <div className="flex flex-col w-full justify-center items-center mt-4">
        <table className="w-full text-sm text-center text-gray-500 border-gray-700 overflow-scroll">
          <TableHeading
            list={commonList}
          />
          <tbody className="text-sm text-gray-500">
            {consignmentResponse && consignmentResponse.length > 0 ? (
              consignmentResponse.map((item, index) => {
                const travelDistance =
                  (item.vehiclePunches.updatedDistance || item.vehiclePunches.finalDistance - item.vehiclePunches.initialDistance);
                const isChecked = consignmentList.includes(item._id);
                return (
                  <tr key={item._id} className="bg-white border-b hover:bg-gray-50 dark:bg-gray-800">
                    <td className="px-4 py-2">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) =>
                          e.target.checked
                            ? handleSelectConsignment(item._id, travelDistance)
                            : handleDeselectConsignment(item._id, travelDistance)
                        }
                      />
                    </td>
                    <td className="px-4 py-2 font-medium text-gray-900 whitespace-nowrap">
                      {index + 1}
                    </td>
                    <td className="px-4 py-2">{truncateText(item.created_by.name)}</td>
                    <td className="px-4 py-2">{truncateText(item.vehicle.vehicleNumber)}</td>
                    <td className="px-4 py-2">{truncateText(item.vehicle.driverContact)}</td>
                    <td className="px-4 py-2">{truncateText(item.srcAddress)}</td>
                    <td className="px-4 py-2">{truncateText(item.deliveryAddress)}</td>
                    <td className="px-4 py-2">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-2">{travelDistance} km</td>
                  </tr>
                );
              })
            ) : (
              <tr className="bg-white border-b">
                <td colSpan={9} className="text-center px-6 py-4">
                  No Consignments Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {consignmentResponse.length > 0 && <div className="flex flex-col justify-start items-start w-full mt-4 px-6">
          <table className="mt-4 px-6 table-auto border-collapse">
            <tbody>
              <tr className="text-right">
                <td className="font-medium pr-2 w-32 ">Total Distance</td>
                <td className='text-left w-20 pl-4 '>
                  <div className="text-red-600 font-semibold">{totalDistance}</div>
                </td>
                <td className='text-left pl-2 '>KM</td>
              </tr>
              <tr className="text-right">
                <td className="font-medium pr-2 w-32">Rate</td>
                <td className="flex items-center justify-start">
                  <input 
                    type="number" 
                    value={rate}
                    onChange={(e) => setRate(e.target.value)}
                    className="border-2 w-full text-left pl-3" 
                  />
                </td>
                <td className="text-left pl-2">Rs/KM</td>
              </tr>
              <tr className="text-right">
                <td className="font-medium pr-2 w-32">Wages</td>
                <td className="flex items-center justify-end">
                  <input 
                    type="number" 
                    value={dailyWages}
                    onChange={(e) => setDailyWages(e.target.value)}
                    className="border-2 w-full text-left pl-3" 
                  />
                </td>
                <td className="text-left pl-2">Rs/Day</td>
              </tr>
              <tr className="text-right">
                <td className="font-medium pr-2 w-32 pb-4">Other Payment</td>
                <td className="flex items-center justify-end pb-4">
                  <input 
                    type="number" 
                    value={otherPayment}
                    onChange={(e) => setOtherPayment(e.target.value)}
                    className="border-2 w-full text-left pl-3" 
                  />
                </td>
                <td className="text-left pl-2 pb-4">Rs/Day</td>
              </tr>
              <tr className="text-right border-t-2 border-b-2 border-gray-800">
                <td className="font-medium pr-2 w-32">Total Amount</td>
                <td className='text-left w-20 pl-4'>
                  <div className="text-blue-600 font-semibold">{(totalDistance * Number(rate)) + Number(dailyWages) + Number(otherPayment)}</div>
                </td>
                <td className='text-left pl-2'>Rs</td>
              </tr>
            </tbody>
          </table>
          <button 
            className='mt-4 text-white bg-blue-600 hover:bg-blue-500 font-medium rounded-sm text-sm px-5 py-2.5'
            onClick={requestPayment}
          > Request for payment</button>
        </div>}
      </div></>}
      {(["Admin", "Super Admin"].includes(empData.role) &&  empData.department ==="Department Head" ) && 
        <>
          {consignmentListAdmin?.length > 0 ? ( 
            consignmentListAdmin.map((item) => (
              <div key={item._id} className="mb-6">
                {/* Driver Info */}
                <table className="min-w-full text-sm border bg-gray-200 mt-4">
                  <tbody>
                    <tr>
                      <th className="px-4 py-2 text-left">Driver Name</th>
                      <td className="px-4 py-2">{item.vehicleData?.[0]?.driverName || '—'}</td>
                      <th className="px-4 py-2 text-left">Driver Contact</th>
                      <td className="px-4 py-2">{item.vehicleData?.[0]?.driverContact || '—'}</td>
                      <th className="px-4 py-2 text-left">Vehicle No</th>
                      <td className="px-4 py-2">{item.vehicleData?.[0]?.vehicleNumber || '—'}</td>
                      <td className="px-4 py-2 bg-green-500 text-center text-white text-semibold">
                            {item?.totalAmount} Rs
                          </td>
                      <td className="px-4 py-2 text-left">
                        <button
                          className="text-white hover:bg-blue-400 bg-blue-500 rounded-sm px-4 py-2"
                          onClick={() => consignmentApprovedByAdmin(item._id)}
                        >
                          Approved
                        </button>
                      </td>
                      {/* <td className="px-4 py-2 text-left">
                        <button
                          className="text-white hover:bg-red-400 bg-red-500 rounded-sm px-4 py-2"
                          onClick={() => consignmentApprovedByAdmin(item._id)}
                        >
                          Reject
                        </button>
                      </td> */}
                    </tr>
                  </tbody>
                </table>


                {item.consignmentList?.length > 0 && (
                  <table className="w-full text-sm text-center">
                    <TableHeading list={commonList} />
                    <tbody>
                      {item.consignmentList.map((cons, idx) => (
                        <tr
                          key={cons._id}
                          className="bg-white border-b hover:bg-gray-100"
                        >
                          <td className="px-4 py-2">{idx + 1}</td>
                          <td className="px-4 py-2">
                            {truncateText(item.createdBy?.name)}
                          </td>
                          <td className="px-4 py-2">
                            {truncateText(cons.srcAddress)}
                          </td>
                          <td className="px-4 py-2">
                            {truncateText(cons.deliveryAddress)}
                          </td>
                          <td className="px-4 py-2">
                            {new Date(cons.createdAt).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-2">
                            {item.vehiclePunches?.[idx]?.updatedDistance} km
                          </td>
                          <td className='px-4 py-2'> 
                            <button
                              className="text-white hover:bg-red-400 bg-red-500 rounded-sm px-4 py-2"
                              onClick={() => consignmentRejectByAdmin(cons._id, item._id)}
                            >
                              <MdDeleteForever />
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr className="bg-yellow-300 border-b">
                          <td className="px-4 py-2">Rate <span className='font-bold'>{item?.rate}</span> Rs/KM </td>
                          <td className="px-4 py-2">
                             Other Payment <span className='font-bold'>{item?.otherPayment}</span> Rs
                          </td>
                          <th className="px-4 py-2">Wages</th>
                          <td className="px-4 py-2">
                            {item?.dailyWages} Rs
                          </td>

                          <th className="px-4 py-2">Total Distance</th>
                          <td className="px-4 py-2">
                            {item?.totalDistance} km
                          </td>
                          <td></td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            ))
          ) : (
            <p className="text-gray-500 w-full text-center">No consignments to display.</p>
          )}
        </>
      }
      {/* {
        empData.role === 'Super Admin' &&
        <div className="flex justify-center items-center mt-4">
          <h1 className="text-2xl font-semibold text-red-500">
            Super Admin Section
          </h1>
        </div>
      } */}
    </div>
  );
};

export default PaymentRequest;